import React from "react";

const DifferenceContent = props => {
  return <React.Fragment></React.Fragment>;
};

export default DifferenceContent;
